"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Subscription = exports.BillingPeriod = exports.BillingAddress = exports.Order = exports.OrderCommercial = exports.OrderItem = exports.ServiceLocation = exports.Location = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.Location = typebox_1.Type.Object({
    addressLine1: typebox_1.Type.Optional(typebox_1.Type.String()),
    addressLine2: typebox_1.Type.Optional(typebox_1.Type.String()),
    addressNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    city: typebox_1.Type.String(),
    country: typebox_1.Type.String(),
    county: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Number()),
    state: typebox_1.Type.String(),
    zip: typebox_1.Type.String(),
});
exports.ServiceLocation = typebox_1.Type.Object({
    address: exports.Location,
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    gateCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    latitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    longitude: typebox_1.Type.Optional(typebox_1.Type.Number()),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    svcLocLocID: typebox_1.Type.Optional(typebox_1.Type.String()),
    svcLocOrderID: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.OrderItem = typebox_1.Type.Object({
    baseCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    baseRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    name: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordItemOrdID: typebox_1.Type.Optional(typebox_1.Type.String()),
    quantity: typebox_1.Type.Optional(typebox_1.Type.Number()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxable: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    unitCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.OrderCommercial = typebox_1.Type.Object({
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDateActual: typebox_1.Type.Optional(typebox_1.Type.String()),
    deliveryDateRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    description: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentMaterial: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentSizeRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentSizeUnit: typebox_1.Type.Optional(typebox_1.Type.String()),
    equipmentTypeRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommEqTypeIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommEquipmentIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommOrdID: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordCommVendorIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    vendorName: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickupDateActual: typebox_1.Type.Optional(typebox_1.Type.String()),
    pickupDateRequested: typebox_1.Type.Optional(typebox_1.Type.String()),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    quantity: typebox_1.Type.Number(),
    serviceDays: typebox_1.Type.Optional(typebox_1.Type.String()),
    serviceFrequency: typebox_1.Type.Optional(typebox_1.Type.Number()),
    serviceFrequencyUnit: typebox_1.Type.Optional(typebox_1.Type.String()),
    soNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    sortOrder: typebox_1.Type.Optional(typebox_1.Type.Number()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxable: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
    unitCost: typebox_1.Type.Optional(typebox_1.Type.Number()),
    unitRate: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.Order = typebox_1.Type.Object({
    commercialOrder: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderCommercial)),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.String(),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    oneTimeCharges: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderItem)),
    ordSubIDNullable: typebox_1.Type.Optional(typebox_1.Type.String()),
    ordSvcLocID: typebox_1.Type.Optional(typebox_1.Type.String()),
    recurringCharges: typebox_1.Type.Optional(typebox_1.Type.Array(exports.OrderItem)),
    serviceLocation: exports.ServiceLocation,
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.BillingAddress = typebox_1.Type.Object({
    addressLine1: typebox_1.Type.String(),
    addressLine2: typebox_1.Type.Optional(typebox_1.Type.String()),
    city: typebox_1.Type.Optional(typebox_1.Type.String()),
    country: typebox_1.Type.Optional(typebox_1.Type.String()),
    state: typebox_1.Type.Optional(typebox_1.Type.String()),
    zip: typebox_1.Type.Optional(typebox_1.Type.String()),
});
exports.BillingPeriod = typebox_1.Type.Object({
    autopaySource: typebox_1.Type.Optional(typebox_1.Type.String()),
    billPeriodSubID: typebox_1.Type.String(),
    billingDay: typebox_1.Type.Optional(typebox_1.Type.Number()),
    billingTerm: typebox_1.Type.Optional(typebox_1.Type.Number()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    number: typebox_1.Type.Optional(typebox_1.Type.Number()),
    orders: typebox_1.Type.Optional(typebox_1.Type.Array(exports.Order)),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    subscriptionNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxPercent: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
exports.Subscription = typebox_1.Type.Object({
    accountExecutive: typebox_1.Type.Optional(typebox_1.Type.String()),
    accountManager: typebox_1.Type.Optional(typebox_1.Type.String()),
    autopaySource: typebox_1.Type.Optional(typebox_1.Type.String()),
    billingAddress: typebox_1.Type.Optional(exports.BillingAddress),
    billingDay: typebox_1.Type.Optional(typebox_1.Type.Number()),
    billingFrequency: typebox_1.Type.String(),
    billingTerm: typebox_1.Type.Optional(typebox_1.Type.Number()),
    billingType: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    createdByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    customer: typebox_1.Type.Optional(typebox_1.Type.Any()), // Replace with Customer.AllianceCustomerTransport schema if available
    customerID: typebox_1.Type.String(),
    endTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    futureServicePeriodCount: typebox_1.Type.Optional(typebox_1.Type.Number()),
    haulerID: typebox_1.Type.Optional(typebox_1.Type.String()),
    id: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedAt: typebox_1.Type.Optional(typebox_1.Type.String()),
    lastUpdatedByUserID: typebox_1.Type.Optional(typebox_1.Type.String()),
    number: typebox_1.Type.Optional(typebox_1.Type.String()),
    orders: typebox_1.Type.Array(exports.Order),
    poNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    soNumber: typebox_1.Type.Optional(typebox_1.Type.String()),
    startTimestamp: typebox_1.Type.Optional(typebox_1.Type.String()),
    status: typebox_1.Type.Optional(typebox_1.Type.String()),
    taxPercent: typebox_1.Type.Optional(typebox_1.Type.Number()),
});
//# sourceMappingURL=operations.js.map